import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip);

export function PieChart({data}) {
  const countChart =data?.map(chart=>chart.count)
  const chartInfo = data?.map(chart=>chart.key)
  const chartStyles = {
    labels: chartInfo,
    datasets: [
      {
        label: 'Count',
        data: countChart,
        backgroundColor: [
          '#43a5f5',
          '#e10f0f',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          '#2E8B57',
          'rgba(153, 102, 255, 1)',
          '#9ACD32',
          'rgba(255, 159, 64, 1)',
          '#FF4500',
          '#708090',
        ],
        borderColor: [
          '#43a5f5',
          '#e10f0f',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          '#2E8B57',
          'rgba(153, 102, 255, 1)',
          '#9ACD32',
          'rgba(255, 159, 64, 1)',
          '#FF4500',
          '#708090',
        ],
        borderWidth: 1,
      },
    ],
  };
  const option = {
    // title: { display: false }, legend: { display: false },
    tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var meta = dataset._meta[Object.keys(dataset._meta)[0]];
          var total = meta.total;
          var currentValue = dataset.data[tooltipItem.index];
          var percentage = parseFloat((currentValue/total*100).toFixed(1));
          return currentValue + ' (' + percentage + '%)';
        },
        title: function(tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        }
      }
    }
  }

  return <Pie data={chartStyles} width="160px" height="160px" options={option}/>;
}
